import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { mapFontValuesToSerializedStyles } from 'components/publicWebsiteV2/util/mappers';
import { ThemeContext } from '../../../context';
import { mapWeddingAccountToWebsiteDateProp } from '../../../../../util/websiteDateUtil';
import LocationDateModuleHorizontal from './displayTypes/LocationDateModuleHorizontal';
import LocationDateModuleVertical from './displayTypes/LocationDateModuleVertical';

type LocationDateModuleProps = {
  className?: string;
  textAlignment: string;
};

const LocationDateModule = ({
  className,
  textAlignment,
}: LocationDateModuleProps): JSX.Element | null => {
  const {
    wedding,
    components: { globalHeaderFontValues, globalBodyFontValues },
  } = useContext(ThemeContext);

  if (!wedding) return null;

  const { city, state_province } = wedding;
  const websiteDate = mapWeddingAccountToWebsiteDateProp(wedding, undefined);
  const hasWeddingLocation = Boolean(city || state_province);

  if (!websiteDate && !hasWeddingLocation) return null;

  const dateLocationComponent = wedding?.public_theme_v2?.components?.DATE_AND_LOCATION;
  const orientation = dateLocationComponent?.option_type_values?.ORIENTATION?.value;

  const headerFontStyles = mapFontValuesToSerializedStyles(
    globalHeaderFontValues,
    dateLocationComponent?.fonts?.HEADER?.[1]
  );
  const bodyFontStyles = mapFontValuesToSerializedStyles(
    globalBodyFontValues,
    dateLocationComponent?.fonts?.BODY?.[1]
  );

  const props = {
    city,
    state: state_province,
    websiteDate,
    className,
    headerFontStyles,
    bodyFontStyles,
    textAlignment,
  };

  const Container = styled.div`
    width: 100%;
    padding-top: 40px;
  `;

  return (
    <Container>
      {orientation === 'HORIZONTAL' ? (
        <LocationDateModuleHorizontal {...props} />
      ) : (
        <LocationDateModuleVertical {...props} />
      )}
    </Container>
  );
};

export default LocationDateModule;
